export const notifyMeasurer = () => {
  //@ts-expect-error
  if (window.oaiq) {
    // window.oaiq(
    //   "measure",
    //   "registration_done",
    //   {
    //     type: "custom",
    //   },
    //   { custom_event_name: "registration_done" }
    // )
    //@ts-expect-error
    oaiq("measure", "registration_completed", {
      type: "customer_action",
      amount: 0,
      currency: "USD",
    })
  }
}
